module.exports = __webpack_public_path__ + "img/informationLaw.ce310b4a.jpg";